import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { ArrowRight, Briefcase, Building2 } from 'lucide-react';
import { FREELANCER_PLAN, ORGANIZATION_PLAN } from '@/config/tierPricing';

export default function AccountTypeStep({ onSelect }) {
  return (
    <>
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">Welcome to SAFER-i™</CardTitle>
        <CardDescription>Choose your account type to get started</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <button
          onClick={() => onSelect('freelancer')}
          className="w-full p-6 border-2 rounded-xl hover:border-primary hover:bg-primary/5 transition-all text-left group"
          data-testid="freelancer-option"
        >
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center flex-shrink-0">
              <Briefcase className="w-7 h-7 text-white" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-semibold text-lg">{FREELANCER_PLAN.name}</h3>
                <Badge className="bg-emerald-500 text-xs" data-testid="freelancer-price-badge">
                  SGD ${FREELANCER_PLAN.priceSgd.toFixed(2)}/month
                </Badge>
              </div>
              <p className="text-sm text-muted-foreground">
                Independent associate consultant working with multiple small organizations on safety projects.
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
        </button>

        <button
          onClick={() => onSelect('organization')}
          className="w-full p-6 border-2 rounded-xl hover:border-primary hover:bg-primary/5 transition-all text-left group"
          data-testid="organization-option"
        >
          <div className="flex items-start gap-4">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center flex-shrink-0">
              <Building2 className="w-7 h-7 text-white" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-semibold text-lg">Organization</h3>
                <Badge variant="outline" className="text-xs" data-testid="organization-price-badge">
                  SGD ${ORGANIZATION_PLAN.onboardingSgd.toLocaleString(undefined, { minimumFractionDigits: 2 })}/year
                </Badge>
              </div>
              <p className="text-sm text-muted-foreground">
                Company or enterprise needing culture intelligence for your team.
              </p>
            </div>
            <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
        </button>
      </CardContent>
      <CardFooter className="justify-center">
        <p className="text-sm text-muted-foreground">
          Already have an account? <Link to="/login" className="text-primary hover:underline">Log in</Link>
        </p>
      </CardFooter>
    </>
  );
}
